import React, { useEffect } from 'react';
import { Box, Flex, useColorMode } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

/**
 * Auth shell — always light for brand logo contrast.
 * Soft logo-derived wash behind a clean white card.
 */
export default function AuthLayout() {
  const { colorMode, setColorMode } = useColorMode();

  useEffect(() => {
    if (colorMode !== 'light') setColorMode('light');
  }, [colorMode, setColorMode]);

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      px={{ base: 4, sm: 6 }}
      py={{ base: 8, md: 12 }}
      position="relative"
      overflowX="hidden"
      overflowY="auto"
      bg="#F4F8FC"
    >
      <Box
        position="absolute"
        inset={0}
        pointerEvents="none"
        aria-hidden
        bgImage={`
          radial-gradient(ellipse 70% 55% at 12% 18%, rgba(30, 122, 216, 0.22), transparent 58%),
          radial-gradient(ellipse 55% 45% at 88% 12%, rgba(232, 120, 32, 0.16), transparent 55%),
          radial-gradient(ellipse 50% 40% at 78% 88%, rgba(217, 43, 90, 0.08), transparent 50%),
          linear-gradient(165deg, #F7FBFF 0%, #F4F8FC 45%, #EEF3F8 100%)
        `}
      />

      <Box
        position="relative"
        w="100%"
        maxW="420px"
        flexShrink={0}
        my={{ base: 2, md: 0 }}
        bg="white"
        borderWidth="1px"
        borderColor="rgba(201, 218, 234, 0.9)"
        borderRadius="16px"
        p={{ base: 6, sm: 8 }}
        boxShadow="0 18px 50px rgba(10, 22, 40, 0.08), 0 2px 8px rgba(10, 22, 40, 0.04)"
      >
        <Outlet />
      </Box>
    </Flex>
  );
}
